/**
 * รับรองกงสุล (MFA legalisation) — Q&A Wave 3 (destination & problem-solving).
 *
 * ACCURACY POLICY (ตรวจทาน 2026-08-06)
 * - นิติกรณ์: กองสัญชาติและนิติกรณ์ กรมการกงสุล กระทรวงการต่างประเทศ ถนนแจ้งวัฒนะ
 *   200 บาท/ตราประทับ (ปกติ) · 400 บาท/ตราประทับ (ด่วน) — consular.mfa.go.th
 * - สถานะ Apostille ของไทยอ้างจาก src/data/legal-facts.ts (มีผล 28 ก.พ. 2027)
 * - ห้ามระบุค่าบริการของเรา · ห้ามระบุผลล่วงหน้า · เวลาเป็นช่วงโดยประมาณ
 */
import type { LgzQA } from "./questions-500";

const TAIL =
  "ข้อมูล ณ ส.ค. 2026 — ระเบียบของกรมการกงสุลและของสถานทูตปลายทางเปลี่ยนแปลงได้ โปรดยืนยันเช็กลิสต์กับหน่วยงานผู้รับเอกสารก่อนยื่นทุกครั้ง";
const CTA =
  "สอบถามค่าบริการและรายการเอกสารเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล";
const FEE =
  "ค่าธรรมเนียมนิติกรณ์เป็นอัตราของกรมการกงสุล 200 บาทต่อตราประทับแบบปกติ และ 400 บาทต่อตราประทับแบบด่วน";

export const LGZ_QA_WAVE3: LgzQA[] = [
  {
    slug: "lgz-w3-เอกสารถูกตีกลับสาเหตุ",
    q: "สาเหตุที่เอกสารถูกตีกลับจากนิติกรณ์บ่อยที่สุดมีอะไรบ้าง",
    aShort:
      "สาเหตุที่พบบ่อยคือ ใช้สำเนาถ่ายเองแทนสำเนาที่หน่วยงานผู้ออกรับรอง ตัวสะกดชื่อไม่ตรงหนังสือเดินทาง เอกสารเกินอายุที่ปลายทางรับ คำแปลไม่ครบตราประทับ และทำผิดลำดับขั้นตอน",
    aLong:
      "วิธีป้องกันคือ คัดต้นฉบับใหม่จากหน่วยงานผู้ออกทุกครั้ง ตรวจตัวสะกดชื่อและนามสกุลให้ตรงหนังสือเดินทางเล่มที่ใช้เดินทางจริง แปลข้อความในตราประทับและลายมือชื่อให้ปรากฏในคำแปล และตรวจว่าเอกสารเอกชนผ่านการรับรองลายมือชื่อก่อนเข้าสายนิติกรณ์ · " +
      FEE + " · " + CTA + " · " + TAIL,
    synonyms: ["เอกสารถูกตีกลับ กงสุล", "mfa legalisation rejected reasons", "แก้ปัญหานิติกรณ์ไม่ผ่าน"],
    cluster: "problem",
  },
  {
    slug: "lgz-w3-อายุเอกสาร",
    q: "เอกสารที่ยื่นนิติกรณ์มีอายุจำกัดไหม",
    aShort:
      "กรมการกงสุลไม่ได้กำหนดอายุเอกสารทุกประเภท แต่หน่วยงานปลายทางส่วนใหญ่กำหนดเอง โดยมักรับเอกสารที่คัดใหม่ภายในสามถึงหกเดือน",
    aLong:
      "จึงควรตรวจเงื่อนไขอายุของปลายทางก่อนเริ่มขั้นตอน เพราะหากคัดต้นฉบับไว้นานแล้วค่อยเดินเรื่อง อาจต้องคัดใหม่และเสียเวลาซ้ำ สำหรับเอกสารที่มีวันหมดอายุในตัวเอง เช่น หนังสือรับรองบางประเภท ให้เผื่อเวลาสำหรับทุกขั้นตอนภายในอายุนั้น · " +
      CTA + " · " + TAIL,
    synonyms: ["อายุเอกสาร นิติกรณ์", "document validity legalisation thailand", "เอกสารเก่าเกินยื่นได้ไหม"],
    cluster: "documents",
  },
  {
    slug: "lgz-w3-ยื่นแทนได้ไหม",
    q: "เจ้าของเอกสารไม่อยู่ในไทย ให้ผู้อื่นยื่นนิติกรณ์แทนได้ไหม",
    aShort:
      "ขั้นตอนนิติกรณ์ให้ผู้รับมอบยื่นแทนได้เมื่อเอกสารและเอกสารแสดงตนครบ แต่ขั้นตอนที่ต้องลงนามต่อหน้าผู้รับรอง เจ้าของเอกสารต้องดำเนินการเอง",
    aLong:
      "แนวทางที่ใช้ได้เมื่ออยู่ต่างประเทศคือ ลงนามและรับรองลายมือชื่อที่สถานทูตหรือสถานกงสุลไทยในประเทศที่พำนัก หรือใช้ระบบรับรองของประเทศนั้นตามที่ปลายทางยอมรับ แล้วส่งเอกสารกลับมาเข้าสายนิติกรณ์ในไทย · " +
      CTA + " · " + TAIL,
    synonyms: ["ยื่นกงสุลแทนได้ไหม", "third party submission mfa thailand", "อยู่ต่างประเทศ รับรองเอกสารไทย"],
    cluster: "process",
  },
  {
    slug: "lgz-w3-เอกสารต่างประเทศใช้ในไทย",
    q: "เอกสารที่ออกจากต่างประเทศจะใช้ในไทยต้องรับรองอย่างไร",
    aShort:
      "ต้องผ่านการรับรองในประเทศต้นทางตามระบบของประเทศนั้น แล้วประทับตราสถานทูตหรือสถานกงสุลไทยที่รับผิดชอบ จากนั้นแปลเป็นภาษาไทยและยื่นนิติกรณ์ในไทยเมื่อหน่วยงานผู้รับกำหนด",
    aLong:
      "ลำดับนี้สำคัญ เพราะหน่วยงานไทยตรวจตราของสถานทูตไทยเป็นหลัก หากนำเอกสารเข้ามาแปลก่อนโดยไม่มีตราต้นทาง จะต้องส่งกลับไปทำใหม่ ตรวจด้วยว่าชื่อในเอกสารต่างประเทศสะกดตรงกับหนังสือเดินทางที่ใช้ในไทย · " +
      FEE + " · " + CTA + " · " + TAIL,
    synonyms: [
      "เอกสารต่างประเทศ ใช้ในไทย รับรอง",
      "foreign document use in thailand legalisation",
      "inbound legalisation thailand",
    ],
    cluster: "inbound",
  },
  {
    slug: "lgz-w3-hague-vs-non-hague",
    q: "ปลายทางเป็นประเทศภาคีเฮกกับไม่ภาคี ขั้นตอนต่างกันอย่างไรในปี 2026",
    aShort:
      "ในปี 2026 ไทยยังไม่ออกตรา Apostille จึงต้องใช้สายนิติกรณ์กรมการกงสุลและตราสถานทูตปลายทางทั้งสองกรณี ความต่างจะเกิดหลังอนุสัญญามีผลกับไทยในวันที่ 28 กุมภาพันธ์ 2027",
    aLong:
      "สำหรับประเทศภาคี เมื่ออนุสัญญามีผลกับไทยแล้ว เอกสารไทยจะใช้ตรา Apostille แทนขั้นตอนสถานทูตได้ ส่วนประเทศที่ไม่เป็นภาคียังต้องยื่นสถานทูตปลายทางตามเดิม เอกสารที่มีกำหนดยื่นก่อนวันมีผลควรทำสายปัจจุบันให้จบเพื่อไม่พลาดกำหนด · " +
      CTA + " · " + TAIL,
    synonyms: [
      "hague กับ non hague ต่างกัน",
      "apostille vs legalisation thailand 2026",
      "ประเทศภาคีเฮก เอกสารไทย",
    ],
    cluster: "compare",
  },
  {
    slug: "lgz-w3-หนังสือมอบอำนาจไปต่างประเทศ",
    q: "หนังสือมอบอำนาจที่จะใช้ต่างประเทศต้องผ่านขั้นตอนใด",
    aShort:
      "เป็นเอกสารเอกชน ต้องลงนามต่อหน้าทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารก่อน แล้วยื่นนิติกรณ์กรมการกงสุล และประทับตราสถานทูตปลายทางเมื่อกำหนด",
    aLong:
      "ควรใช้แบบฟอร์มหรือถ้อยคำที่ผู้รับปลายทางกำหนด เช่น ธนาคาร ทะเบียนที่ดิน หรือทนายในประเทศปลายทาง เพราะข้อความที่ไม่ครบขอบเขตอำนาจทำให้ใช้ไม่ได้แม้ตราประทับครบ ระบุขอบเขตอำนาจ ระยะเวลา และชื่อผู้รับมอบให้ชัดเจน · " +
      FEE + " · " + CTA + " · " + TAIL,
    synonyms: ["หนังสือมอบอำนาจ ใช้ต่างประเทศ", "power of attorney legalisation thailand", "รับรอง poa กงสุล"],
    cluster: "documents",
  },
  {
    slug: "lgz-w3-เอกสารการศึกษาสมัครเรียน",
    q: "ทรานสคริปต์และปริญญาบัตรสำหรับสมัครเรียนต่างประเทศต้องรับรองแบบไหน",
    aShort:
      "ใช้ฉบับที่สถานศึกษาออกและรับรอง แปลเป็นภาษาที่มหาวิทยาลัยกำหนด แล้วยื่นนิติกรณ์กรมการกงสุลและตราสถานทูตปลายทางเมื่อมหาวิทยาลัยหรือหน่วยงานตรวจวุฒิกำหนด",
    aLong:
      "หลายมหาวิทยาลัยรับเอกสารที่ส่งตรงจากสถานศึกษาโดยไม่ต้องรับรองเพิ่ม จึงควรอ่านเงื่อนไขก่อนเพื่อไม่เสียเวลา หากต้องรับรอง ให้เตรียมทั้งทรานสคริปต์และใบรับรองสำเร็จการศึกษา และยื่นพร้อมกันเพื่อให้วันที่ตราประทับสอดคล้อง · " +
      CTA + " · " + TAIL,
    synonyms: ["รับรองทรานสคริปต์ สมัครเรียน", "transcript legalisation thailand", "ปริญญาบัตร รับรองกงสุล"],
    cluster: "documents",
  },
  {
    slug: "lgz-w3-เอกสารสมรสต่างประเทศ",
    q: "จะจดทะเบียนสมรสในต่างประเทศ ต้องรับรองเอกสารอะไรบ้าง",
    aShort:
      "โดยทั่วไปใช้ใบรับรองสถานภาพการสมรส สูติบัตร ทะเบียนบ้าน และเอกสารแสดงตน แปลเป็นภาษาปลายทาง แล้วยื่นนิติกรณ์กรมการกงสุลและตราสถานทูตปลายทาง",
    aLong:
      "รายการเอกสารต่างกันตามประเทศและตามสำนักทะเบียนท้องถิ่น จึงควรขอเช็กลิสต์เป็นลายลักษณ์อักษรจากสำนักทะเบียนปลายทางก่อน หากเคยสมรสหรือหย่า ต้องเตรียมหลักฐานการสิ้นสุดการสมรสที่รับรองแล้วด้วย · " +
      FEE + " · " + CTA + " · " + TAIL,
    synonyms: ["เอกสารแต่งงานต่างประเทศ รับรอง", "marriage documents legalisation thailand", "ใบรับรองโสด กงสุล"],
    cluster: "documents",
  },
  {
    slug: "lgz-w3-ระยะเวลาโดยประมาณ",
    q: "ทั้งสายรับรองใช้เวลาประมาณเท่าไร",
    aShort:
      "ขั้นนิติกรณ์กรมการกงสุลใช้เวลาไม่กี่วันทำการ ส่วนขั้นสถานทูตปลายทางแตกต่างกันมากตามนโยบายของแต่ละสถานทูต จึงควรวางแผนเป็นช่วงและเผื่อวันทำการ",
    aLong:
      "ตัวแปรหลักคือ ความพร้อมของต้นฉบับ จำนวนหน้าที่ต้องแปล คิวของหน่วยงาน และช่วงวันหยุดราชการหรือวันหยุดของสถานทูต การเลือกตราประทับแบบด่วนที่คิด 400 บาทต่อตราประทับช่วยลดเวลาขั้นนิติกรณ์ แต่ไม่ลดเวลาขั้นสถานทูต · " +
      CTA + " · " + TAIL,
    synonyms: ["นิติกรณ์ใช้เวลากี่วัน", "legalisation timeline thailand", "รับรองเอกสารด่วน กี่วัน"],
    cluster: "speed",
  },
  {
    slug: "lgz-w3-ต่างจังหวัดส่งเอกสาร",
    q: "อยู่ต่างจังหวัดจะดำเนินเรื่องรับรองเอกสารได้อย่างไร",
    aShort:
      "ทำได้โดยจัดหาต้นฉบับหรือสำเนารับรองจากหน่วยงานในจังหวัดของตน แล้วส่งเอกสารเข้ามาดำเนินการในกรุงเทพ พร้อมหนังสือมอบอำนาจเมื่อขั้นตอนนั้นให้ยื่นแทนได้",
    aLong:
      "ควรส่งด้วยบริการที่ติดตามสถานะได้ และถ่ายภาพเอกสารทุกหน้าก่อนส่งเพื่อใช้ตรวจสอบ กรณีต้องลงนามต่อหน้าผู้รับรอง ให้นัดล่วงหน้าและรวมทุกฉบับที่ต้องลงนามให้เสร็จในครั้งเดียว · " +
      CTA + " · " + TAIL,
    synonyms: ["ต่างจังหวัด รับรองเอกสาร", "upcountry legalisation service thailand", "ส่งเอกสารมากรุงเทพ รับรอง"],
    cluster: "location",
  },
  {
    slug: "lgz-w3-ตรวจสอบตราประทับ",
    q: "ผู้รับเอกสารปลายทางตรวจสอบตราประทับของเราได้อย่างไร",
    aShort:
      "ปลายทางตรวจจากตราประทับและลายมือชื่อเจ้าหน้าที่บนเอกสาร โดยเทียบกับตัวอย่างที่หน่วยงานเก็บไว้ และอาจติดต่อหน่วยงานผู้ออกเพื่อยืนยัน",
    aLong:
      "ดังนั้นห้ามแยกหน้าหรือถอดเย็บเอกสารที่ประทับตราแล้ว ห้ามเขียนหรือแก้ไขข้อความเพิ่ม และควรเก็บสำเนาสีของทุกหน้าไว้เป็นหลักฐานก่อนส่งต้นฉบับออกไป · " +
      CTA + " · " + TAIL,
    synonyms: ["ตรวจสอบตราประทับ กงสุล", "verify legalisation stamp thailand", "ปลายทางเช็คเอกสารอย่างไร"],
    cluster: "problem",
  },
  {
    slug: "lgz-w3-ค่าธรรมเนียมราชการรวมอะไร",
    q: "ค่าธรรมเนียมที่ต้องจ่ายให้ราชการในสายรับรองมีอะไรบ้าง",
    aShort:
      "หลักคือค่าธรรมเนียมนิติกรณ์ของกรมการกงสุล 200 บาทต่อตราประทับแบบปกติ และ 400 บาทต่อตราประทับแบบด่วน ส่วนค่าธรรมเนียมสถานทูตปลายทางแต่ละแห่งกำหนดเอง",
    aLong:
      "ค่าธรรมเนียมคิดต่อตราประทับ ไม่ใช่ต่อชุด ดังนั้นเอกสารหลายฉบับจะมีจำนวนตราประทับหลายรายการ ควรนับจำนวนฉบับที่ต้องรับรองให้ชัดเจนตั้งแต่ต้นเพื่อประมาณค่าธรรมเนียมราชการได้ถูกต้อง · " +
      CTA + " · " + TAIL,
    synonyms: ["ค่าธรรมเนียมนิติกรณ์", "mfa legalisation fee thailand", "ค่าตราประทับกงสุล 200 400"],
    cluster: "price",
  },
];
